export default __webpack_public_path__ + "static/NuvemFiscalNFSe2-45d06ec12fb401e47a3327d6f2421723.png";